import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Warehouse } from 'app/models/warehouse.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlmacenService {
  constructor(private http: HttpClient) {}

  getAlmacenes(): Observable<Warehouse[] | any> {
    return this.http.get(environment.apiUrl + 'warehouse');
  }

  getAlmacen(id: number): Observable<Warehouse | any> {
    return this.http.get(environment.apiUrl + 'warehouse/' + id);
  }

  updateAlmacen(id: number, value: any): Observable<any> {
    return this.http.patch(environment.apiUrl + 'warehouse/' + id, value);
  }

  saveAlmacen(value: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'warehouse', value);
  }

  deleteAlmacen(id: number): Observable<any> {
    return this.http.delete(environment.apiUrl + 'warehouse/' + id);
  }

  // Método para verificar stock disponible en un almacén específico
  getStockByWarehouse(warehouseId: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}warehouse/${warehouseId}/stocks`);
  }
}